export default {
  Monthly: 'Monthly',
  // BiMonthly: 'Bi-Monthly',
  // Quarterly: 'Quarterly',
  Yearly: 'Yearly'
}